// Font-size ratios (relative to settings.fontSize) shared by the Staging
// and Live preview cards, so both panels scale identically.
export const PREVIEW_LABEL_RATIO = 0.15;   // reference / title line
export const PREVIEW_BODY_RATIO = 0.25;    // verse text / lyrics
export const PREVIEW_SONG_BODY_RATIO = 0.2; // song title + lyrics
export const PREVIEW_WELCOME_RATIO = 0.3;  // idle "SleekHear" welcome heading
export const PREVIEW_WELCOME_SUBTITLE_RATIO = 0.1; // welcome subtitle
export const PREVIEW_LABEL_MARGIN = '8px';
